import { defineComponent as _defineComponent } from 'vue'
import { onMounted, onUpdated, ref } from 'vue'
import type { PropType } from 'vue'
import type { Game } from '@/models/Game'
import type { ViewProperties } from '@/models/ViewProperties'
import type { Reservation } from '@/models/Reservation'

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'TicketsGame',
  props: {
  viewProperties: {
    required: true,
    type: Object as PropType<ViewProperties>
  },
},
  emits: ['delete', 'save', 'calendar-updated', 'delete-res'],
  setup(__props, { expose, emit }) {
  expose();

const props = __props




const editMode = ref<boolean>(false)

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const seats = ref([])

const fadeOut = ref(false)
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const elementId = `tickets-game-${props.viewProperties.game.uid}`
const reg = () => fadeOut.value = true

onMounted(() => {
  props.viewProperties.game.register(reg)
})

onUpdated(() => {
  props.viewProperties.game.register(reg)
})

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const edit = () => {
  editMode.value = true
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const cancel = () => {
  editMode.value = false
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const save = (game: Game) => {
  emit('save', game)
  editMode.value = false
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars


// eslint-disable-next-line @typescript-eslint/no-unused-vars
const calendarUpdated = (calendar: unknown) => {
  emit('calendar-updated', calendar)
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const deleteRes = (res: Reservation) => {
  emit('delete-res', res, props.viewProperties.game.uid)
}


const __returned__ = { props, editMode, seats, fadeOut, elementId, reg, edit, cancel, save, emit, calendarUpdated, deleteRes, onMounted, onUpdated, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})